import { ApiService } from '@/apiConnection/ApiService';
import { Urls } from '@/apiConnection/urls';
import { CustomInputComponent } from '@/components/custom-input/custom-input.component';
import { CustomModalComponent } from '@/components/custom-modal/custom-modal.component';
import { LoadingComponent } from '@/components/loading/loading.component';
import { Utils } from '@/utils/utils';
import { Component, Input, Output, EventEmitter, ChangeDetectorRef, OnInit, signal } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';

@Component({
  selector: 'app-office-form',
  imports: [
    CustomModalComponent,
    ReactiveFormsModule,
    CustomInputComponent,
    LoadingComponent,
  ],
  templateUrl: './office-form.component.html',
  styleUrl: './office-form.component.scss',
})
export class OfficeFormComponent implements OnInit {
  @Input() id: number = 0;
  @Input() office: any = null;
  @Output() closeFunction = new EventEmitter<any>();
  @Output() acceptFunction = new EventEmitter<any>();

  public loading = signal(false);
  public saving = signal(false);
  public saveForm: FormGroup = new FormGroup({});

  constructor(
    private apiService: ApiService,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    this.createForm();

    if (this.office) {
      this.saveForm.patchValue(this.office);
    }
  }

  createForm() {
    this.saveForm = new FormGroup({
      name: new FormControl('', [Validators.required]),
      prefix: new FormControl(null),
      sequence_start: new FormControl(1, [Validators.min(1)]),
      sequence_start_refund: new FormControl(1, [Validators.min(1)]),
    });
  }

  saveEntity() {
    if (this.saveForm.valid) {
      this.saving.set(true);

      this.apiService.save(Urls.urls.offices, this.saveForm.value, this.id).subscribe({
        next: (response: any) => {
          Utils.notification.success(this.id ? 'Oficina actualizada' : 'Oficina creada');
          this.acceptFunction.emit(response);
          this.closeFormFunction();
        },
        error: (error: any) => {
          Utils.notification.alert(Utils.extractErrorMessage(error) || 'Error al guardar la oficina');
          this.saving.set(false);
        },
        complete: () => {
          this.saving.set(false);
        }
      });
    } else {
      Utils.notification.alert('Debe completar todos los campos obligatorios');
    }
  }

  acceptFormFunction() { this.saveEntity(); }
  closeFormFunction() { this.closeFunction.emit(); }
}
